import { render, staticRenderFns } from "./AlertPopUp.vue?vue&type=template&id=168ec235&scoped=true"
import script from "./AlertPopUp.vue?vue&type=script&lang=js"
export * from "./AlertPopUp.vue?vue&type=script&lang=js"
import style0 from "./AlertPopUp.vue?vue&type=style&index=0&id=168ec235&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ec235",
  null
  
)

export default component.exports